import React, { useEffect } from "react";
import { connect } from "react-redux";
import * as layoutService from "../view/layoutService";
import { withMainLayout } from "../view/LayoutHOCs"
import { InfoBoxes } from "../info-boxes/InfoBoxes";
import { useHistory } from "react-router-dom";
import MlDetectionTableSection from "./MlDetectionTableSection";
//import { ShieldAlert, Activity, GitCompareArrows, BrainCircuit } from "lucide-react";



const breadcrumbs = [
    {
        text: "Home",
        redirectTo: "/",
        iconClassName: "icon-home"
    },
    {
        text: "ML Detection Results",
        redirectTo: "/mldetection",
    }
]


function MlDetectionPage() {

    const history = useHistory();

    useEffect(() => {
        layoutService.setPageTitle('ML Detection')
        layoutService.setBreadcrumbs(breadcrumbs)
    }, [history.location])

    return (
        <>
            <InfoBoxes />
            {/* <div className="container-fluid">
                <div className="card oct_analysis-card-v2 oct_ml-page-hero mb-4">
                    <div className="row align-items-center g-4">
                        <div className="col-lg-7">
                            <div className="oct_ml-page-hero__eyebrow">
                                <BrainCircuit size={16} />
                                Offline AIML workspace
                            </div>
                            <h2 className="oct_ml-page-hero__title">Configuration Action Anomaly Detection</h2>
                            <p className="oct_ml-page-hero__text">
                                Review login behavior alerts and configuration-action analysis in one place, with offline Ollama reasoning,
                                config-diff context, and rule-impact correlation.
                            </p>
                            <div className="oct_ml-page-hero__tags">
                                <span>Offline Ollama</span>
                                <span>Config diff aware</span>
                                <span>Validation correlation</span>
                            </div>
                        </div>
                        <div className="col-lg-5 mt-3 mt-lg-0">
                            <div className="row g-3">
                                <div className="col-md-4 mb-2 mb-md-0">
                                    <div className="oct_ml-page-feature">
                                        <div className="oct_ml-page-feature__icon">
                                            <Activity size={18} />
                                        </div>
                                        <div className="oct_ml-page-feature__copy">
                                            <span className="oct_ml-page-feature__title">Login Count</span>
                                            <span className="oct_ml-page-feature__text">Existing AIML result stream</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 mb-2 mb-md-0">
                                    <div className="oct_ml-page-feature">
                                        <div className="oct_ml-page-feature__icon">
                                            <GitCompareArrows size={18} />
                                        </div>
                                        <div className="oct_ml-page-feature__copy">
                                            <span className="oct_ml-page-feature__title">Config Action</span>
                                            <span className="oct_ml-page-feature__text">Offline Ollama correlation flow</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="oct_ml-page-feature oct_ml-page-feature--warning">
                                        <div className="oct_ml-page-feature__icon">
                                            <ShieldAlert size={18} />
                                        </div>
                                        <div className="oct_ml-page-feature__copy">
                                            <span className="oct_ml-page-feature__title">Impact Aware</span>
                                            <span className="oct_ml-page-feature__text">Rules, MSBs, transitions</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
            <MlDetectionTableSection />
        </>
    )

}

export default withMainLayout(connect()(MlDetectionPage));
